import { render, staticRenderFns } from "./shandui.vue?vue&type=template&id=12d4f28d&scoped=true"
import script from "./shandui.vue?vue&type=script&lang=js"
export * from "./shandui.vue?vue&type=script&lang=js"
import style0 from "./shandui.vue?vue&type=style&index=0&id=12d4f28d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4f28d",
  null
  
)

export default component.exports